module.exports = __webpack_public_path__ + "static/media/jivo.c533a921.png";